import { AxiosInstance } from 'axios'
import { stringify } from 'qs'
import { InjectionKey } from '@vue/composition-api'

export class DashboardApi {
  constructor(private client: AxiosInstance, private uri: string) {}

  private path(path: string): string {
    return this.uri + path
  }

  getAggregateScores(
    period: string,
    owners: string[],
    teams: string[],
    projects: string[]
  ) {
    return this.client
      .get(this.path(`/aggregate-scores`), {
        params: { period, owners, teams, projects },
        paramsSerializer: params =>
          stringify(params, { arrayFormat: 'repeat', skipNulls: false })
      })
      .then(response => {
        return response?.data || []
      })
  }

  getScoreTrend(
    period: string,
    grouping: string,
    owners: string[],
    teams: string[],
    projects: string[]
  ) {
    return this.client
      .get(this.path(`/score-trend`), {
        params: { period, grouping, owners, teams, projects },
        paramsSerializer: params =>
          stringify(params, { arrayFormat: 'repeat', skipNulls: false })
      })
      .then(response => {
        return response?.data || []
      })
  }

  getLeaderboards(period: string) {
    return this.client
      .get(this.path(`/leaderboards`), {
        params: { period },
        paramsSerializer: params =>
          stringify(params, { arrayFormat: 'repeat', skipNulls: false })
      })
      .then(response => {
        return response?.data || []
      })
  }
}

export const DashboardApiKey: InjectionKey<DashboardApi> = Symbol()
